import React, {Component} from 'react';
import {observer} from "mobx-react";
import GridGallery from "../../Helpers/GridGallery/GridGallery";
import Aspect from "../../Helpers/Aspect";
import LazyBg from "../../Helpers/LazyBg";
import AttachmentSpoiler from "./AttachmentSpoiler";
import LazyBlock from "../../Helpers/LazyBlock";

class Image extends Component {
  render() {
    if(this.props.data.spoiler && !this.props.data.show_spoiler) {
      return (
        <AttachmentSpoiler data={this.props.data} />
      )
    }

    return (
      <div style={{maxWidth:'100%', width: 400}} className="center pr">
        <GridGallery listMode="chat" items={[ this.props.data ]} index="image" />
        {/*
        <Aspect pa={true} className="bg-w2" aspect={`${this.props.data.height}:${this.props.data.width}`}>
                  <LazyBg className="w100 h100" style={{backgroundPosition:'top center',backgroundSize:'cover',backgroundImage:`url('/autoresize/600x600${this.props.data.image}')`}}/>
                </Aspect>
        <img src={this.props.data.image} />
        */}
      </div>
    )
  }
}

export default observer(Image);